export default "__VITE_ASSET__139f52ce__"